import { render, staticRenderFns } from "./SuggestionsList.vue?vue&type=template&id=fa2f278e"
import script from "./SuggestionsList.vue?vue&type=script&lang=js"
export * from "./SuggestionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports